import { render, staticRenderFns } from "./PreferredVendorsDialog.vue?vue&type=template&id=3f6a6f64&scoped=true&"
import script from "./PreferredVendorsDialog.vue?vue&type=script&lang=js&"
export * from "./PreferredVendorsDialog.vue?vue&type=script&lang=js&"
import style0 from "./PreferredVendorsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6a6f64",
  null
  
)

/* custom blocks */
import block0 from "./PreferredVendorsDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports